import { render, staticRenderFns } from "./answer-info.vue?vue&type=template&id=2be84cec&scoped=true&"
import script from "./answer-info.vue?vue&type=script&lang=js&"
export * from "./answer-info.vue?vue&type=script&lang=js&"
import style1 from "./answer-info.vue?vue&type=style&index=1&id=2be84cec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be84cec",
  null
  
)

export default component.exports